import { render, staticRenderFns } from "./FreeSamples.vue?vue&type=template&id=3f3d2c20&scoped=true&"
import script from "./FreeSamples.vue?vue&type=script&lang=js&"
export * from "./FreeSamples.vue?vue&type=script&lang=js&"
import style0 from "./FreeSamples.vue?vue&type=style&index=0&id=3f3d2c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d2c20",
  null
  
)

export default component.exports